import React, {useState} from 'react'
import FadeIn from './FadeIn'
import Modal from 'react-bootstrap/Modal'
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";

const Modal_Bootstrap = ({openModal, setOpenModalStateInParent, modalTitle, modalContents}) => {
    const [show, setShow] = useState(false)
    const [once, setOnce] = useState(false)

    if (!show && openModal){// && !useRegularModal) {
        setShow(true)
    }

    const handleHide = () =>{
        setShow(false)
        if (setOpenModalStateInParent) setOpenModalStateInParent(false)
    }

    return (
        <>
      <Modal
        show={show}
        onHide={handleHide}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="bootstrap-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {modalTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {modalContents}
          </p>
        </Modal.Body>
        <Modal.Footer>
            <p>&nbsp;</p>
        </Modal.Footer>
      </Modal>
    </>





        /*
        <FadeIn delay={500} duration={450}>
        <div className="modal-blacken"></div>

        <div className="modal-main">
            <div className="modal-title">
                <h1>{modalTitle}</h1>
            </div>
            <div className="modal-contents">
                {modalContents}
            </div>
            <div className="modal-button-bar">
                <button onClick={()=>setOpen(false)}>Close</button>
            </div>
        </div>
        
        </FadeIn>*/
    )
}

export default Modal_Bootstrap
